import * as TypeGraphQL from "type-graphql";
export var TradeExecutionHistoryScalarFieldEnum;
(function (TradeExecutionHistoryScalarFieldEnum) {
    TradeExecutionHistoryScalarFieldEnum["id"] = "id";
    TradeExecutionHistoryScalarFieldEnum["ticker"] = "ticker";
    TradeExecutionHistoryScalarFieldEnum["action"] = "action";
    TradeExecutionHistoryScalarFieldEnum["timestamp"] = "timestamp";
    TradeExecutionHistoryScalarFieldEnum["accounts"] = "accounts";
    TradeExecutionHistoryScalarFieldEnum["createdAt"] = "createdAt";
    TradeExecutionHistoryScalarFieldEnum["expiresAt"] = "expiresAt";
})(TradeExecutionHistoryScalarFieldEnum || (TradeExecutionHistoryScalarFieldEnum = {}));
TypeGraphQL.registerEnumType(TradeExecutionHistoryScalarFieldEnum, {
    name: "TradeExecutionHistoryScalarFieldEnum",
    description: undefined,
});
//# sourceMappingURL=TradeExecutionHistoryScalarFieldEnum.js.map